import React from 'react';
import { Typography, List } from 'antd';
import { Link } from 'react-router-dom';
import type { LegalSection } from '../content/legalTypes';
import { LEGAL_ENTITY_NAME, LEGAL_LAST_UPDATED } from '../config/legal';

const { Title, Paragraph, Text } = Typography;

export interface LegalDocumentPageProps {
  title: string;
  sections: LegalSection[];
  backTo?: string;
  backLabel?: string;
}

/**
 * Renders a legal document from structured sections (privacy, terms, cookies).
 */
export const LegalDocumentPage: React.FC<LegalDocumentPageProps> = ({
  title,
  sections,
  backTo = '/',
  backLabel = 'Back to home',
}) => (
  <div className="legal-document">
    <Paragraph>
      <Link to={backTo}>{backLabel}</Link>
    </Paragraph>
    <Title level={2}>{title}</Title>
    <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
      {LEGAL_ENTITY_NAME} · Last updated {LEGAL_LAST_UPDATED}
    </Text>
    {sections.map((section) => (
      <div key={section.id || section.title} id={section.id} style={{ marginBottom: 28 }}>
        <Title level={4}>{section.title}</Title>
        {section.paragraphs.map((p) => (
          <Paragraph key={p.slice(0, 40)}>{p}</Paragraph>
        ))}
        {section.bullets && section.bullets.length > 0 && (
          <List
            size="small"
            dataSource={section.bullets}
            renderItem={(item) => <List.Item style={{ border: 'none', padding: '4px 0' }}>{item}</List.Item>}
          />
        )}
      </div>
    ))}
  </div>
);

export default LegalDocumentPage;
